
import * as _ from "lodash"
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import {MetricAggregated} from "@/cube/metric-data"
import AnimatedNumber from "@/ui/AnimatedNumber.vue"

@Component({components: {AnimatedNumber, ChangeRateWidget}})
export default class PercentOutlineWidget extends Vue {
  @Prop()
  message: string

  @Prop()
  icon: string

  @Prop()
  metricData: MetricAggregated

  get amountPercent() {
    return _.round(this.metricData.end!.amountPercent * 100)
  }
}
